<template>
  <div class="box18">
    <pageTitle title="常见问题" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "Python和Java都可以做数据开发，哪个入门更容易？",
          answer: [
            "Python是一种面向对象的解释型计算机程序设计语言, 它具有丰富且强大的库。",
            "Python常被称为胶水语言，能够把其他语言制作的各种模块很轻松地结合在一起。相对于Java、C语言等，Python简单易学，更适合没有编程基础的小白入门。",
          ],
        },
        {
          title: "Python大数据和Java大数据哪个就业前景更好？",
          answer: [
            "Java和Python是编程语言，而大数据是一个完整生态，包括了数据采集、数据存储、数据ETL、数据分析、数据挖掘、数据展示等。",
            "Python目前的发展趋势非常好，伴随着大数据和人工智能的发展，Python的应用将得到更广泛的普及。Python语言支持绝大多数大数据生态技术，包括PySpark，PyFlink等技术栈。所以，就目前的趋势来说，Python大数据是比较有前景的。",
          ],
        },
        {
          title: "学完可以达到什么样的水平？",
          answer: [
            "博学谷Python+大数据就业课程包含6大热门行业项目（从离线到实时计算），项目占比达40%。学完该课程，学员技术能力等同于2~4年的Python大数据开发工程师，可完全胜任企业Python大数据开发工程师岗位。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/ai/box17/question.png"),
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box18 {
  padding: 80px 0px 88px;
  width: 100%;
  // height: 713px;
  background: url("../../../assets/coursePage/pythonData/box18.png") no-repeat;
  background-size: cover;
}
</style>
